import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output, TemplateRef, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DetailToolbarComponent } from 'src/app/shared/detail-toolbar.component';

export interface WizardSetting {
    stepSubTitle: string;
    backButtonText?: string;
    nextButtonText: string;
    nextButtonQaId?: string;
    nextButton2Text: string;
    isNextButton2Visible: boolean;
}

@Component({
    selector: 'nova-wizard',
    templateUrl: './wizard.component.html',
    styleUrls: ['./wizard.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgClass,
        MatIconModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        DetailToolbarComponent,
        MatLegacyButtonModule
    ]
})
export class WizardComponent {
    readonly showWizardStepper = input(false);
    readonly title = input<string>(undefined);
    readonly toolbarTemplate = input<TemplateRef<any>>(undefined);
    readonly repipelineHeaderPreText = input<string>(undefined);
    readonly repipelinedDisplayedContract = input<string>(undefined);
    readonly isRepipelineHeaderBannerAvailable = input<boolean>(undefined);
    readonly stepIndex = input(1);
    readonly lastStepIndex = input(5);
    readonly stepSubTitle = input<string>(undefined);
    readonly backButtonText = input('Back');
    readonly backButtonQaId = input('WizardBackButton');
    readonly unlinkBackButtonFromBrowserActionFlag = input(false); //Remove at TCA-2738 - FF removal ticket
    readonly nextButtonText = input('Next');
    readonly nextButtonQaId = input('WizardNextButton');
    readonly nextButton2Text = input('SEND TO CANDIDATE');
    readonly nextButton2QaId = input('WizardNextButton2');
    readonly isLoading = input(true);
    readonly isNextButtonEnabled = input(true);
    readonly isNextButtonLoading = input(false);
    readonly isNextButton2Visible = input(false);
    readonly isNextButton2Enabled = input(false);
    readonly isNextButton2Loading = input(false);
    backBtnText = computed(() => {
        if (!this.unlinkBackButtonFromBrowserActionFlag()) {
            return 'Back';
        }

        const backButtonText = this.backButtonText() ?? 'Back';
        const stepInfo = this.stepIndex() > 1 ? ` to step ${this.stepIndex() - 1}` : '';
        return backButtonText + stepInfo;
    });

    @Output() previousStepClicked = new EventEmitter();
    @Output() nextStepClicked = new EventEmitter();
    @Output() nextStep2Clicked = new EventEmitter();
    @Output() headerDisplayedContractClicked = new EventEmitter();

    goToPreviousStep(): void {
        this.previousStepClicked.emit();
    }

    goToNextStep(): void {
        this.nextStepClicked.emit();
    }

    goToNextStep2(): void {
        this.nextStep2Clicked.emit();
    }

    gotoContractProfile(): void {
        this.headerDisplayedContractClicked.emit();
    }
}
